import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Base from './base';
import { PermissionItem } from '../models';
/**
 * `Service` The specification service
 */
var Specifications = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function Specifications(sdk) {
    _classCallCheck(this, Specifications);
    return _callSuper(this, Specifications, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Specifications, _Base);
  return _createClass(Specifications, [{
    key: "getSpecificationsPermission",
    value: (
    /**
     * get specification permission
     * apigee link: https://git.autodesk.com/pype/acc-specs-apigee-proxy/blob/beta/.cloudos/apim/api_proxy/api_spec.yaml#L272
     * @param projectId - The project uuid
     * @param  config - Configurable object for overwrite request parameters.
     * @returns a promise with userPermission response: data: PermissionItem, success: boolean, status: string, message: string
     */
    function () {
      var _getSpecificationsPermission = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/userPermissions");
              _context.next = 3;
              return this.HttpService.specsV1.get(url, config);
            case 3:
              response = _context.sent;
              return _context.abrupt("return", _extends({}, response.data, {
                data: PermissionItem.parseV3(response.data.data)
              }));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getSpecificationsPermission(_x, _x2) {
        return _getSpecificationsPermission.apply(this, arguments);
      }
      return getSpecificationsPermission;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Specifications';
    }
  }]);
}(Base);
export default Specifications;